import { BreadCrumbOption } from '@service-victoria/component-library/components/BreadCrumb';

export const Page = {
  title: 'Melbourne travel voucher scheme'
};

export const MAX_RETRIES = 3;

/**
 * Maximum time allowed for keeping the user ssession active wihtout any action
 */
export const SESSION_TIMEOUT_THRESHOLD_MILLISECONDS = 300000;

export const STATUS_CODES = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  CONFLICT: 409,
  PRECONDITION_FAILED: 412, // Before it opens
  UNPROCESSABLE_ENTITY: 422, // After it's all sold out
  INTERNAL_SERVER_ERROR: 500
};

export const Api = {
  CheckAvailability: '/quota',
  SubmitForm: '/voucher'
};

export const REGEX = {
  POSTCODE: /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/,
  POSTCODE_VIC: /^(?:(?:[3]\d|[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/
};

export const GenericValidationErrors = {
  required: 'We can’t help you without this information.',
  nameChars:
    'Sorry, names must start and end with A-Z. Punctuation in the middle is fine. e.g. O’Connor, al-Tammar.',
  validDate: 'That doesn’t look right. Please enter a valid date.', // @TODO - is this okay?
  isNumeric: `Please enter a numeric card number.`, // @TODO - is this okay?
  validLicense: `Please enter a 9-digit card number.`,
  seniorsCardMaxDigits: `Please enter a seniors card number with no more than 10 digits.`,
  proofOfAgeCardMaxDigits: `Please enter a proof of age card number with no more than 10 digits.`
};

export const externalLinks = {
  siteRelAppHomePath: '/services/melbourne-voucher/home',
  beforeYouStart: '#before-you-apply',
  metroVoucherSchemeFaqs: 'https://www.vic.gov.au/melbourne-travel-voucher-scheme-faqs',
  metroVoucherScheme: 'https://www.vic.gov.au/melbourne-travel-voucher-scheme',
  regionalVoucherScheme: 'https://www.vic.gov.au/regional-travel-voucher-scheme',
  metroVoucherSchemeCollectionNotice:
    'https://www.service.vic.gov.au/travel-voucher-scheme-collection-notice',
  svContact: 'https://service.vic.gov.au/contact/',
  djprPrivacy: 'https://djpr.vic.gov.au/privacy',
  svPrivacy: 'https://service.vic.gov.au/privacy-and-security',
  guidelines: 'https://www.vic.gov.au/melbourne-travel-voucher-scheme-guidelines',
  eligibleLGAs:
    'https://www.vic.gov.au/melbourne-travel-voucher-scheme-guidelines#eligible-melbourne-metropolitan-areas'
};

export const contentDates = {
  goLive: '12 March',
  goLiveDay: 'Friday',
  travelPeriodStart: '19 March',
  travelPeriodEnd: '16 May',
  claimStart: '26 April',
  claimDealine: '30 May 2021'
};

export const internalLinks = {
  beforeYouStart: '#before-you-apply'
};

export const AddressValidationErrors = {
  streetName: 'Please enter a valid street address.',
  suburb: 'Please enter a valid suburb.',
  stateVic: "You must choose 'Victoria' to continue.",
  place: 'We can’t help you without this information.',
  postcode: 'Please enter a 4-digit postcode.',
  postcodeVic:
    "Sorry, that's not a Victorian postcode. Victorian postcodes are 4 digits and start with '3'",
  noPostBox: "Sorry, the address can't be a PO Box, GPO Box or Locked Bag.",
  pickAddress:
    "Please choose an address from the list. If your address isn't listed, enter it manually."
};

export const DateValidationErrors = {
  day: 'That doesn’t look right. The day can only be a number between 1 and 31.',
  month: 'That doesn’t look right. The month can only be a number between 1 and 12.',
  year: 'That doesn’t look right. Try entering the year again.',
  invalidDate: 'That date doesn’t exist. Try entering the date again.'
};

export const StorageKeys = {
  State: 'ServiceVictoria.Covid19.State',
  Wizard: 'ServiceVictoria.Covid19.Wizard'
};

export const Routes = {
  Root: '/',
  Home: '/home',
  Transaction: '/Transaction',
  TechnicalError: '/TechnicalError',
  Privacy: '/privacy-policy',
  QuotaExceeded: '/transaction/exceeded-vouchers',
  Others: '*'
};

export const breadCrumbs: BreadCrumbOption[] = [
  {
    text: 'Outdoor and recreation',
    link: 'https://www.service.vic.gov.au/find-services/outdoor-and-recreation'
  },
  {
    text: 'Melbourne travel voucher scheme',
    link: ''
  }
];

/**
 * Date constants values
 */
export const Dates = {
  /**
   * Char seperator between the date different sections (day, month, year)
   */
  DATE_DIVIDER_CHAR: '/',

  /**
   * Date format for full mode
   */
  FULL_DATE_FORMAT: 'DD/MM/YYYY',

  /**
   * Date format for partial mode
   */
  MONTH_YEAR_FORMAT: 'MM/YYYY',

  /**
   * Display date format in UX
   */
  DISPLAY_FORMAT: 'DD MMMM YYYY'
};

export const DefaultErrorResponse = {
  title: 'Sorry, there was a problem processing this request.',
  value: 'Please try again.'
};

/**
 * user setttings as part of OIDC
 */
export const UserManagerSettings = {
  scope: 'openid customer:rw profile email',
  authority: process.env.REACT_APP_AUTHORITY_URL,
  client_id: 'loa'
};

export const USER_MANAGER_SESSION_KEY = `sv-tokenuser:${UserManagerSettings.authority}:${UserManagerSettings.client_id}`;

export const stateOptions: { label: string; value: string }[] = [
  {
    label: 'ACT',
    value: 'ACT'
  },
  {
    label: 'NSW',
    value: 'NSW'
  },
  {
    label: 'NT',
    value: 'NT'
  },
  {
    label: 'QLD',
    value: 'QLD'
  },
  {
    label: 'SA',
    value: 'SA'
  },
  {
    label: 'TAS',
    value: 'TAS'
  },
  {
    label: 'VIC',
    value: 'VIC'
  },
  {
    label: 'WA',
    value: 'WA'
  }
];
